import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'riepilogo-prospetti';
export const ENTITY_PLURAL = 'Riepilogo Prospetti';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Prospetto',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'prospettoCodNome',
  },
  {
    elementLabel: 'Struttura',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaCodNome',
  },
  {
    elementLabel: 'Piano dei Conti',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoContiCodNome',
  },
  {
    elementLabel: 'Tipo',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'tipoPianoConti',
    maxWidth: 80,
    initialHideColumn: true,
  },
  {
    elementLabel: 'Saldo iniziale (01/01)',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'saldoIniziale',
    // sortable: false,
    // hideFilter: true,
    maxWidth: 180,
  },
  {
    elementLabel: 'Saldo iniziale Dare',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'saldoInizialeDare',
    // sortable: false,
    // hideFilter: true,
    maxWidth: 180,
    initialHideColumn: true,
  },
  {
    elementLabel: 'Saldo iniziale Avere',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'saldoInizialeAvere',
    // sortable: false,
    // hideFilter: true,
    maxWidth: 180,
    initialHideColumn: true,
  },

  {
    elementLabel: 'Movimenti Dare',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'movimentiDare',
    // sortable: false,
    // hideFilter: true,
    maxWidth: 180,
  },
  {
    elementLabel: 'Movimenti Avere',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'movimentiAvere',
    // sortable: false,
    // hideFilter: true,
    maxWidth: 180,
  },
  {
    elementLabel: 'Saldo finale (31/12)',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'saldoFinale',
    // sortable: false,
    // hideFilter: true,
    maxWidth: 180,
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
